import React, { useState } from "react";
import TermsModal from "./modal_finwell/TermsMdoal";
import { navigate } from "react-big-calendar/lib/utils/constants";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { clickStreamUser } from "../../utils/AppUtils";

const FooterFinwell = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const authBroker = useSelector((state) => state.auth.authBroker);
  return (
    <>
      <footer
        className="text-left text-muted small mt-2rem footer-finwell pb-3"
        role="contentinfo"
      >
        <p>
          © {new Date().getFullYear()}{" "}
          {t(
            "pwc_us_all_rights_reserved_pwc_us_refers_to_the_us_group_of_member_firms_and_may_sometimes_refer_to_the_pwc_network_each_member_firm_is_a_separate_legal_entity",
          )}
        </p>
        <div className="links-footer">
          <a
            href="https://privacyhub.pwc.com/us/en/financial-wellness/privacy-policy.html"
            target="_blank"
            onClick={() => {
              clickStreamUser(
                `privacy_policy_clicked`,
                {
                  userId: authBroker?.payload?.user?.user_id,
                },
                authBroker,
              );
            }}
          >
            {t("privacy_policy")}
          </a>
          {/* <a href="#">Cookie notice</a> */}
          <a
            href="#"
            onClick={() => {
              clickStreamUser(
                `terms_and_conditions_clicked`,
                {
                  userId: authBroker?.payload?.user?.user_id,
                },
                authBroker,
              );
              setShow(true);
            }}
          >
            {t("terms_and_conditions")}
          </a>
          <a
            href="#"
            onClick={() => {
              clickStreamUser(
                `help_center_clicked`,
                {
                  userId: authBroker?.payload?.user?.user_id,
                },
                authBroker,
              );
              navigate("/help");
            }}
          >
            {t("help_center")}
          </a>
          <a
            href=""
            onClick={() => {
              clickStreamUser(
                `coaching_clicked`,
                {
                  userId: authBroker?.payload?.user?.user_id,
                },
                authBroker,
              );
              navigate("/coaching");
            }}
          >
            {t("coaching")}
          </a>
          {/* <a href="#">Customize cookie settings</a> */}
        </div>
      </footer>
      <TermsModal show={show} setShow={setShow} />
    </>
  );
};

export default FooterFinwell;
